import { queryString, queryStringWithSort } from 'helpers/request';
import { isResponseError, TResponse } from 'models/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import {
  IBatchesSearchForm,
  IBatchesSearchResponse,
  ILicencesSearchForm,
  ILicencesSearchResponse,
  IPrintoutsResponseContent,
  IPrintoutsSearchForm,
  IPrintoutsSearchResponse,
  IWeaponLicencePrintBatchDetails,
  IWeaponLicencePrintBatchHistorySearchResponse,
  IWeaponLicencePrintHistory,
} from 'models/licences';
import { EPerPages, ISortOptions } from 'models/table';
import { apiClient } from 'utils/apiClient';

const getLicences = async (
  page: number,
  size: number,
  sort: ISortOptions | null | undefined,
  query: Partial<ILicencesSearchForm>,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const { data } = await apiClient.post<TResponse<ILicencesSearchResponse>>(
    `${ApiEndpoints.GET_WEAPON_LICENSES()}?${qString}`,
    query,
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};
const getPrintouts = async (
  page: number,
  size: number,
  sort: ISortOptions | null | undefined,
  query: Partial<IPrintoutsSearchForm>,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const { data } = await apiClient.post<TResponse<IPrintoutsSearchResponse>>(
    `${ApiEndpoints.GET_PRINTOUTS()}?${qString}`,
    query,
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getWeaponLicencePrint = async (uniqueId: string) => {
  const { data } = await apiClient.get<TResponse<IPrintoutsResponseContent>>(
    ApiEndpoints.GET_WEAPON_LICENCE_PRINT(uniqueId),
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getWeaponLicencePrintBatch = async (uniqueId: string) => {
  const { data } = await apiClient.get<TResponse<IWeaponLicencePrintBatchDetails>>(
    ApiEndpoints.GET_WEAPON_LICENCE_PRINT_BATCH(uniqueId),
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const searchWeaponLicencePrintBatchPrintouts = async (
  uniqueId: string,
  page: number,
  size: EPerPages,
  sort: ISortOptions | null | undefined,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const { data } = await apiClient.post<TResponse<IPrintoutsSearchResponse>>(
    `${ApiEndpoints.SEARCH_WEAPON_LICENCE_PRINT_BATCH_PRINTOUTS(uniqueId)}?${qString}`,
    {},
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getWeaponLicencePrintBatchHistory = async (
  uniqueId: string,
  page: number,
  size: EPerPages,
) => {
  const qString = queryString({
    page: page - 1,
    size,
  });

  const { data } = await apiClient.get<
    TResponse<IWeaponLicencePrintBatchHistorySearchResponse>
  >(`${ApiEndpoints.GET_WEAPON_LICENCE_PRINT_BATCH_HISTORY(uniqueId)}?${qString}`);

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getBatches = async (
  page: number,
  size: number,
  sort: ISortOptions | null | undefined,
  query: Partial<IBatchesSearchForm>,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const { data } = await apiClient.post<TResponse<IBatchesSearchResponse>>(
    `${ApiEndpoints.GET_BATCHES()}?${qString}`,
    query,
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getWeaponLicencePrintHistory = async (uniqueId: string) => {
  const { data } = await apiClient.get<TResponse<IWeaponLicencePrintHistory[]>>(
    ApiEndpoints.GET_PRINTOUT_HISTORY(uniqueId),
  );
  if (isResponseError(data)) {
    return null;
  }

  return data;
};

export {
  getBatches,
  getLicences,
  getPrintouts,
  getWeaponLicencePrint,
  getWeaponLicencePrintBatch,
  searchWeaponLicencePrintBatchPrintouts,
  getWeaponLicencePrintBatchHistory,
  getWeaponLicencePrintHistory,
};
